export default __webpack_public_path__ + "static/media/galarie5.91aea4b5.jpg";